/**
 *
 * @param {Array} arr Chat list
 * @param {Number} id ID of chat to reset the unread count
 * @returns Same array with the unread count reset of id provided
 */
export const resetUnreadMessages = (arr, id) =>
  arr.map((el) => (el.id === id ? { ...el, unreadMessages: 0 } : el));

/**
 *
 * @param {Object} message Message without format
 */
export const generateListedMessage = (message) => ({
  fromMe: Number(message.fromMe),
  isDeleted: Number(message.isDeleted),
  msgTimeStamp: String(message.msgTimeStamp),
  ack: message.ack,
  body: message.body,
  created_at: message.created_at,
  id: message.id,
  mediaType: message.mediaType,
  mediaUrl: message.mediaUrl,
  observaciones: message.observaciones,
  order: message.order,
  ticketId: message.ticketId,
  serialized: message.serialized,
  answered_message: message.answered_message,
});

/**
 *
 * @param {Object} message Message without format
 * @param {Object} ticket Ticket without format
 * @param {Object} contact contact without format
 */
export const generateQueueListedChat = (message, ticket, contact) => ({
  id: ticket.id,
  status: ticket.status,
  contactId: ticket.contactId,
  queueId: ticket.queueId,
  unreadMessages: ticket.unreadMessages,
  userId: null,
  updated_at: ticket.updated_at,
  contacts: {
    id: ticket.contactId,
    name: contact.name,
    email: contact.email,
    profilePicUrl: contact.profilePicUrl,
  },
  last_message: {
    ack: message.ack,
    body: message.body,
    ticketId: ticket.id,
    created_at: message.created_at,
  },
});
/**
 *
 * @param {Object} listedMessage actual shape of the element
 * @param {Object} ticket Ticket payload
 * @param {Object} message Message payload
 */
export const generateUpdateQueueChat = (listedMessage, ticket, message) => ({
  ...listedMessage,
  unreadMessages: ticket.unreadMessages,
  last_message: {
    ack: message.ack,
    body: message.body,
    ticketId: ticket.id,
    created_at: ticket.created_at,
  },
});

/**
 *
 * @param {Object} listedMessage actual shape of the element
 * @param {Object} ticket Ticket payload
 * @param {Object} message Message payload
 * @param {Boolean} isChatOpen True if is open
 */
export const generateUpdateListChat = (listedMessage, ticket, message, isChatOpen) => ({
  ...listedMessage,
  unreadMessages: isChatOpen ? 0 : ticket.unreadMessages,
  last_message: {
    ...listedMessage.last_message,
    body: message.body,
    ack: message.ack,
    created_at: message.created_at,
  },
});

/**
 * Date formatted for chat messages
 *
 * @param {Date} date
 */
export const dateFormat = (date) => {
  const dateFormatted = date
    .toString()
    .slice(0, 10)
    .split("-")
    .reverse()
    .join("/");
  return dateFormatted;
};
